<template>
  <div class="imports">
    <div class="step">
      <div class="serial">1</div>
      <div class="text">下载模板，填写{{member}}信息</div>
      <Button @click="onDownloadTemplate">下载模板</Button>
    </div>
    <slot>
      <ul>
        <li>
          <Icon type="ios-alert-outline" />
          <span>请按照模板样式填写</span>
        </li>
        <li>
          <Icon type="ios-alert-outline" />
          <span>请勿出现整行为空、单元格为空的情形</span>
        </li>
        <li v-if="type!='ship'">
          <Icon type="ios-alert-outline" />
          <span>一次最多支持导入300个</span>
        </li>
        <li>
          <Icon type="ios-alert-outline" />
          <span>为确保您的{{member}}数据导入正常，建议下载新的模板导入</span>
        </li>
      </ul>
    </slot>
    <div class="step" style="margin-top:30px;">
      <div class="serial">2</div>
      <div class="text">上传填写好的模板</div>
      <UploadFile
        :url="url"
        :format="['xlsx']"
        label="上传文件"
        @onSuccess="onUploadSuccess"
        :data="data"
      ></UploadFile>
      <div v-if="afterUpload" @click="$router.go(-1)" class="looks">查看{{member}}</div>
    </div>
    <Modal v-model="showModal" title="错误信息">
      <h3 style="margin:10px 0;">共{{response.total}}条，其中有{{response.err.length}}条不符合要求，请修改后重新上传</h3>
      <div style="padding: 10px;border:1px solid #dcdee2;">
        <p v-for="(item, index) in response.err" :key="index">{{item}}</p>
      </div>
    </Modal>
    <slot name="success"></slot>
  </div>
</template>

<script>
import UploadFile from "@/components/UploadFile";
const buildConfig = require("../build/" + process.env.BUILD_ENV + ".js");

export default {
  name: "imports",
  components: {
    UploadFile
  },
  props: {
    customSuccess: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      type: this.$route.query.type,
      url: "",
      downloadUrl: "",
      response: {
        err: []
      },
      showModal: false,
      member: "",
      afterUpload: false,
      data: {}
    };
  },
  created() {
    switch (this.type) {
      case "student":
        this.member = "学员";
        this.url = "/api/import/user";
        this.downloadUrl = "/excel/temp/importStudent.xlsx";
        break;
      case "teacher":
        this.member = "讲师";
        this.url = "/api/import/teacher";
        this.downloadUrl = "/excel/temp/importTeacher.xlsx";
        break;
      case "vip":
        this.member = "会员";
        this.url = "/api/import/vipUser";
        this.downloadUrl = "/excel/temp/importVipUser.xlsx";
        break;
      case "sensitiveWords":
        this.member = "敏感词";
        this.url = "/api/import/sensitiveWords";
        this.downloadUrl = "/excel/temp/importSensitiveWords.xlsx";
        break;
      case "assist":
        this.member = "助教";
        this.url = "/api/import/assistant";
        this.downloadUrl = "/excel/temp/importAssistant.xlsx";
        break;
      case "classGradeStudent":
        this.member = "学员";
        this.url = "/api/classGradeStudent/import";
        this.downloadUrl = "/excel/temp/importClassStudent.xlsx";
        this.data = {
          course_basis_id: this.$route.query.course_basis_id,
          class_grade_id: this.$route.query.class_grade_id
        };
        break;
      case "ship":
        this.member = "发货";
        this.url = "/api/ship/import";
        this.downloadUrl = "/excel/temp/bathShip.xlsx";
        break;
    }
  },
  methods: {
    onDownloadTemplate() {
      window.open(buildConfig.BASE_URL + this.downloadUrl);
    },
    onUploadSuccess(data) {
      if (typeof data == "number") {
        this.afterUpload = true;
        this.$Message.success(`共${data}条,全部导入成功`);
      } else {
        this.response = data;
        this.showModal = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.imports {
  ul {
    padding-left: 30px;
    padding-top: 10px;
    li {
      list-style: none;
      font-size: 13px;
      color: #666;
      height: 30px;
      display: flex;
      align-items: center;
      i {
        font-size: 16px;
        margin-right: 10px;
      }
    }
  }
  .looks {
    font-size: 14px;
    color: #2d8cf0;
    padding-left: 20px;
    cursor: pointer;
  }
}
</style>

